import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { useStore } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import * as analytics from 'analytics/performance'
import { getCurrentRoutePath } from 'selectors'
import { setUnpublished } from 'careers/actions/job-ad'
import { httpError } from 'actions/http'

const propTypes = {
  routes: PropTypes.func.isRequired,
}

function Router({ routes }) {
  const store = useStore()
  const lastPathRef = useRef(null)

  const onEnter = async ({ params, request }) => {
    const { dispatch } = store
    const url = new URL(request.url)
    const location = { pathname: url.pathname, search: url.search }
    if (lastPathRef.current === location.pathname) return null
    lastPathRef.current = location.pathname

    dispatch(httpError(null))
    dispatch(setUnpublished(false))

    const path = getCurrentRoutePath(params, location.pathname)
    analytics.onPageLoadEvent({
      route: path,
      routeParams: params,
    })
    return null
  }

  const buildRoutes = routesArr =>
    routesArr.map(route => {
      const { path, element, children, loader } = route
      return {
        path,
        element,
        loader: loader || onEnter,
        children: children ? buildRoutes(children) : undefined,
      }
    })

  const routeObjects = buildRoutes(routes(onEnter))

  const routerRef = useRef(null)
  if (!routerRef.current) {
    routerRef.current = createBrowserRouter(routeObjects)
  }

  return <RouterProvider router={routerRef.current} />
}

Router.propTypes = propTypes

export default Router
